import { DocumentSnapshot } from "../../../types/firebase.types";

/**
 * this function alter notification list by fetching and injecting each `documentRef` document
 * */
export const injectNotificationDocument = async (notificationSnapshots: DocumentSnapshot[]) => {
  const modifiedNotifications = [];
  for (const notificationSnapshot of notificationSnapshots) {
    const notification: Record<string, any> = {
      ...notificationSnapshot.data(),
      id: notificationSnapshot.id,
      ref: notificationSnapshot.ref,
      snapshot: notificationSnapshot,
    };
    const documentRef = notification.ref;

    try {
      const documentSnapshot = await documentRef.get();

      if (documentSnapshot.exists) {
        modifiedNotifications.push({
          ...notification,
          meta: {
            document: {
              ...documentSnapshot.data(),
              id: documentSnapshot.id,
              ref: documentSnapshot.ref,
            },
            collectionName: notification.collection,
          },
        });
      }
    } catch (ex: any) {
      console.log(ex.message);
    }
  }
  return modifiedNotifications;
};
